import { render, staticRenderFns } from "./patentlookout-details.vue?vue&type=template&id=bd0291b8&scoped=true&"
import script from "./patentlookout-details.vue?vue&type=script&lang=js&"
export * from "./patentlookout-details.vue?vue&type=script&lang=js&"
import style0 from "./patentlookout-details.vue?vue&type=style&index=0&id=bd0291b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0291b8",
  null
  
)

export default component.exports